import DispatchOrders from '../views/dispatch_orders/Index.vue'
import {checkauth} from "../Helper";

export default [
    {
        path: '/dispatch-orders',
        name: 'dispatch_orders',
        component: DispatchOrders,
        beforeEnter (to,from,next){
            checkauth().then( response =>{
                    if(response){
                        next();
                    }else{
                        next('/login');
                    };
                }

            )
        }
    },
]
